module.exports = __webpack_public_path__ + "static/media/JBM-Logo-transparent.909810ef.png";